var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "exam" } },
    [
      _c("QuestionGroup", { staticClass: "question-content" }),
      _vm._v(" "),
      _c("QuestionList", { staticClass: "question-list" }),
      _vm._v(" "),
      _c(
        "modal",
        {
          ref: "modal",
          attrs: { id: "modal" },
          model: {
            value: _vm.confirmSubmit,
            callback: function ($$v) {
              _vm.confirmSubmit = $$v
            },
            expression: "confirmSubmit",
          },
        },
        [
          _c("p", [
            _vm._v("本当に提出してもよろしいですか？※再提出はできません"),
          ]),
          _vm._v(" "),
          _c(
            "div",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "btn",
                {
                  on: {
                    click: function ($event) {
                      return _vm.cancelSubmit()
                    },
                  },
                },
                [_vm._v("キャンセル")]
              ),
              _vm._v(" "),
              _c(
                "btn",
                {
                  attrs: { type: "danger" },
                  on: {
                    click: function ($event) {
                      return _vm.finishExam()
                    },
                  },
                },
                [_vm._v("確認")]
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }